import React from "react";

const AllImages = React.createContext({});
export default AllImages;
